import axios from "../../config/axiosConfig";
import { CREATE_BANK_SLIP_ENTRY, GET_BANK_SLIP_ENTRIES, BANK_SLIP_ENTRY_REQUEST, UPDATE_BANK_SLIP_ENTRY, DELETE_BANK_SLIP_ENTRY, BANK_SLIP_ENTRY_REQUEST_FAILURE, GET_AVAILABLE_BANK_RECEIPT_TRANSACTION, GET_BANK_SLIP_ENTRY_PAGE, BANK_SLIP_ENTRY_REQUEST_SUCCESS } from "../types";

export const getBankSlipEntriesWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id'
      };
      return axios.get("/bank-slip-entry/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BANK_SLIP_ENTRY_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getBankSlipEntries = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/bank-slip-entry/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BANK_SLIP_ENTRIES, payload: response?.data?.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getValidatedIncrementedSlipNoBankSlipEntry = (bookId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      if(bookId) {
        params = { ...params, bookId: bookId };
      }
      const response = await axios.get("/bank-slip-entry/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getAvailableBankReceiptTransactions = (bookId, bankSlipEntryId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, bookId: bookId, bankSlipEntryId: bankSlipEntryId };
      return axios.get("/bank-slip-entry/available-bank-receipt-transaction", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_AVAILABLE_BANK_RECEIPT_TRANSACTION, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getBankSlipEntryById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST });
    
      return axios.get(`/bank-slip-entry/get/${id}`).then((response) => {
        dispatch({ type: BANK_SLIP_ENTRY_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createBankSlipEntry = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST });
      return axios.post("/bank-slip-entry/add", data,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_BANK_SLIP_ENTRY, payload: response.data });
        } else {
          dispatch({
            type: BANK_SLIP_ENTRY_REQUEST_FAILURE,
            error: "Bank Slip Entry create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateBankSlipEntry = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST });
      const { auth } = getState();
      return axios.put("/bank-slip-entry/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.BankSlip?.Company_Id || auth.company?.id,
            finyearId: data.BankSlip?.Finyear_Id || auth.finyear?.id,
            customerId: data.BankSlip?.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_BANK_SLIP_ENTRY,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: BANK_SLIP_ENTRY_REQUEST_FAILURE,
            error: "Bank Slip Entry update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteBankSlipEntry = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST });
      const { auth } = getState();
      return axios.delete(`/bank-slip-entry/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_BANK_SLIP_ENTRY, id: id });
          const include = ['id', 'Slip_No', 'Book_Id', 'Date'].join(',');
          const searchCols = ['Slip_No'].join(',');
          const { transaction: { bankSlipEntries: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getBankSlipEntriesWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_SLIP_ENTRY_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};